import { Card, Row, Tabs } from "antd";
import { Loader } from "../Loader";
import { IntervalSelector } from "../IntervalSelector";
import { memo, useCallback, useState } from "react";
import { useTabItems } from "./hooks/useTabItems";
import { useFetchHistory } from "./hooks/useFetchHistory";
import { useFormatHistoryData } from "./hooks/useFormatHistoryData";
import { Chart } from "./components/Chart";
import "./styles.scss";

type CreatedItemsProps = {
  data: any;
  isLoading: boolean;
  isRecalculated: boolean;
};

const CreatedItems = ({
  data,
  isLoading,
  isRecalculated,
}: CreatedItemsProps) => {
  const [active, setActive] = useState<string>("0");

  const [granularity, setGranularity] = useState<number>(1);

  const { tabItems } = useTabItems(data, granularity);

  const { isLoading: isHistoryLoading, data: history } = useFetchHistory(
    granularity,
    active,
    isRecalculated,
  );

  const { chardData } = useFormatHistoryData(history, granularity);

  const onChangeTab = useCallback((key: string) => {
    setActive(key);
  }, []);

  return (
    <Card className="dashboard-card created-items">
      <Row className="w-100 justify-space-between">
        <p className="text my-0">Created Items</p>
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
      <Row className="w-100 d-block h-100">
        {!isLoading ? (
          <Row className="mt-4">
            <Tabs
              items={tabItems}
              tabPosition="bottom"
              className="created-items__tabs"
              activeKey={active}
              onChange={onChangeTab}
            />
            <Chart data={chardData} isLoading={isHistoryLoading} />
          </Row>
        ) : (
          <Loader />
        )}
      </Row>
    </Card>
  );
};

export default memo(CreatedItems);
